<template>
    <div>
        <b-button id="button_collapse" block href="#" v-b-toggle.wrapper_details_collapse variant="info" class="text-left font-weight-bold">   
            Ver detalhes do rastreamento
            <span class="when-opened font-weight-normal">
                <b-icon-chevron-up></b-icon-chevron-up>
            </span>
            <span class="when-closed font-weight-normal">
                <b-icon-chevron-down></b-icon-chevron-down>
            </span>
        </b-button>
        <b-collapse id="wrapper_details_collapse">
            <b-container id="wrapper_details">
                <b-row class="wrapper_detail_item">
                    <b-col cols="1" class="text-left"><b-img src="@/assets/box_green_small.png" fluid></b-img></b-col>
                    <b-col class="text-left"><strong>Nota entregue</strong></b-col>
                    <b-col class="text-right">26/12/2019 01:50</b-col>
                </b-row>
                <b-row class="wrapper_detail_item">
                    <b-col cols="8">Rota Iniciada - Contagem -> Pouso Alegre/MG</b-col>
                    <b-col class="text-right">25/12/2019 18:45</b-col>
                </b-row>
                <b-row class="wrapper_detail_item">
                    <b-col cols="8">Entrou em rota de transferência - Contagem -> Pouso Alegre/MG</b-col>
                    <b-col class="text-right">25/12/2019 12:50</b-col>
                </b-row>
                <b-button block href="#" variant="info" class="text-center">
                    <b-img src="@/assets/photo_green_small.png" fluid class="h-100"></b-img>
                    Clique para ver a foto do canhoto
                </b-button>
            </b-container>
        </b-collapse>   
    </div>
</template>

<script>
export default {
    name: 'Details'
}
</script>

<style>
#wrapper_details_collapse{
    background: white;
}

.wrapper_detail_item{
    padding: 0 20px 0 20px;
    margin: 0px 0 2px 0;
}

.collapse_item{
    background: white;
    padding: 10px;
    margin-left: 10px;
}

</style>

<style scoped>
a{
    margin: 10px 0 10px 0 !important;
    background: white;
    color: black;
    border: 0;
}

img{
    height: 25px;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}

.when-opened, .when-closed{
    float: right;
}

.btn {
  text-transform: unset !important;
}

#button_collapse{
    width: calc(100% - 20px);
    margin: 10px !important;
}
</style>
